import { render, staticRenderFns } from "./FormItemListView.vue?vue&type=template&id=33cbd406&scoped=true"
import script from "./FormItemListView.vue?vue&type=script&lang=js"
export * from "./FormItemListView.vue?vue&type=script&lang=js"
import style0 from "./FormItemListView.vue?vue&type=style&index=0&id=33cbd406&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cbd406",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33cbd406')) {
      api.createRecord('33cbd406', component.options)
    } else {
      api.reload('33cbd406', component.options)
    }
    module.hot.accept("./FormItemListView.vue?vue&type=template&id=33cbd406&scoped=true", function () {
      api.rerender('33cbd406', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/forms/FormItemListView.vue"
export default component.exports